// @ts-nocheck
import React from 'react';
import { useState, useEffect } from 'react';

function ErrorBanner({
  message = 'GET /admin/dashboard → 403 Forbidden',
  top = 20,
  left = '50%',
  transform = 'translateX(-50%)',
  zIndex = 9999,
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() =>{
    setTimeout(()=>{
      setVisible(true)
    }, 1000)
  },[])

  if(!visible){
    return <></>
  }

  return (
    <div
      style={{
        position: 'fixed',
        top,
        left,
        transform,
        zIndex,
        background: '#fee2e2',
        color: '#991b1b',
        padding: '12px 16px',
        borderRadius: 8,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        fontFamily: 'sans-serif',
        fontSize: 34,
        fontWeight: 500,
      }}
    >
      {message}
    </div>
  );
}

function TextLineSkeleton({
  width = '100%',
  height = 16,
  radius = 6,
  style = {},
  className = '',
}) {
  return (
    <>
      <style>{`
        .text-line-skeleton {
          position: relative;
          overflow: hidden;
          display: block;
          background: #3a7cdf; /* più visibile */
        }

        .text-line-skeleton::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 50%;
          background: linear-gradient(
            90deg,
            rgba(255,255,255,0) 0%,
            rgba(255,255,255,0.8) 50%,
            rgba(255,255,255,0) 100%
          );
          animation: shimmer 1.2s infinite;
        }

        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(200%);
          }
        }
      `}</style>

      <span
        className={`text-line-skeleton ${className}`.trim()}
        style={{
          width,
          height,
          borderRadius: radius,
          ...style,
        }}
        aria-hidden="true"
      />
    </>
  );
}

// Test rapido:
// <div style={{ padding: 20, background: '#fff' }}>
//   <TextLineSkeleton width="80%" />
// </div>

// Esempio d'uso:
// <TextLineSkeleton />
// <TextLineSkeleton width="60%" height={14} />



const styles = {
  page: {
    minHeight: '100vh',
    background: '#08111f',
    color: '#e5eefc',
    fontFamily: 'Arial, Helvetica, sans-serif',
  },
  layout: {
    display: 'flex',
    minHeight: '100vh',
  },
  sidebar: {
    width: '270px',
    background: '#0b1728',
    borderRight: '1px solid #16263c',
    display: 'flex',
    flexDirection: 'column',
  },
  sidebarHeader: {
    padding: '24px',
    borderBottom: '1px solid #16263c',
  },
  sidebarLabel: {
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    color: '#7f93b3',
  },
  sidebarTitle: {
    marginTop: '10px',
    fontSize: '28px',
    fontWeight: 700,
    color: '#f8fbff',
  },
  nav: {
    padding: '18px 14px',
    flex: 1,
  },
  navButton: {
    width: '100%',
    border: '1px solid transparent',
    background: 'transparent',
    color: '#9cb0ce',
    textAlign: 'left',
    padding: '14px 16px',
    borderRadius: '18px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  navButtonActive: {
    background: '#0e4ca4',
    color: '#ffffff',
    borderColor: '#2d69c0',
    boxShadow: '0 10px 24px rgba(14, 76, 164, 0.35)',
  },
  supportBadge: {
    background: '#173e73',
    color: '#dce9ff',
    borderRadius: '999px',
    padding: '3px 8px',
    fontSize: '11px',
    fontWeight: 700,
  },
  systemBoxWrap: {
    padding: '14px',
    borderTop: '1px solid #16263c',
  },
  systemBox: {
    background: 'linear-gradient(180deg, #0e4ca4 0%, #0b3570 100%)',
    color: '#ffffff',
    borderRadius: '18px',
    padding: '18px',
    border: '1px solid #2d69c0',
    boxShadow: '0 12px 28px rgba(14, 76, 164, 0.28)',
  },
  systemTitle: {
    fontSize: '14px',
    fontWeight: 700,
  },
  systemStatus: {
    fontSize: '28px',
    fontWeight: 700,
    marginTop: '10px',
  },
  systemText: {
    marginTop: '6px',
    fontSize: '14px',
    color: '#d7e6ff',
  },
  main: {
    flex: 1,
  },
  header: {
    background: '#0b1728',
    borderBottom: '1px solid #16263c',
    padding: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '20px',
    flexWrap: 'wrap',
  },
  headerTitle: {
    margin: 0,
    fontSize: '34px',
    fontWeight: 700,
    color: '#f8fbff',
  },
  headerText: {
    marginTop: '6px',
    color: '#8ea5c7',
    fontSize: '14px',
  },
  headerActions: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  search: {
    width: '300px',
    padding: '12px 14px',
    borderRadius: '16px',
    border: '1px solid #20324c',
    background: '#091321',
    color: '#e5eefc',
    fontSize: '14px',
    outline: 'none',
  },
  buttonLight: {
    padding: '12px 16px',
    borderRadius: '16px',
    border: '1px solid #223754',
    background: '#101d31',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 600,
    color: '#d5e2f7',
  },
  buttonDark: {
    padding: '12px 16px',
    borderRadius: '16px',
    border: '1px solid #2d69c0',
    background: '#0e4ca4',
    color: '#ffffff',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 600,
    boxShadow: '0 10px 22px rgba(14, 76, 164, 0.3)',
  },
  content: {
    padding: '24px',
  },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: '16px',
  },
  card: {
    background: '#0d192b',
    border: '1px solid #182a42',
    borderRadius: '20px',
    boxShadow: '0 10px 24px rgba(0, 0, 0, 0.22)',
  },
  statCard: {
    padding: '20px',
  },
  statLabel: {
    fontSize: '14px',
    color: '#8ea5c7',
    fontWeight: 600,
  },
  statRow: {
    marginTop: '14px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: '12px',
  },
  statValue: {
    fontSize: '34px',
    fontWeight: 700,
    color: '#f8fbff',
    width: '50px'
  },
  changeBadge: {
    background: '#123567',
    color: '#dce9ff',
    borderRadius: '999px',
    padding: '6px 10px',
    fontSize: '12px',
    fontWeight: 700,
    border: '1px solid #2357a0',
  },
  statNote: {
    marginTop: '8px',
    fontSize: '14px',
    color: '#8ea5c7',
  },
  splitGrid: {
    display: 'grid',
    gridTemplateColumns: '1.7fr 1fr',
    gap: '24px',
    marginTop: '24px',
  },
  panelHeader: {
    padding: '18px 20px',
    borderBottom: '1px solid #182a42',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    flexWrap: 'wrap',
  },
  panelTitle: {
    fontSize: '20px',
    fontWeight: 700,
    margin: 0,
    color: '#f8fbff',
  },
  panelText: {
    fontSize: '14px',
    color: '#8ea5c7',
    marginTop: '4px',
  },
  pillRow: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  pill: {
    padding: '8px 12px',
    borderRadius: '999px',
    background: '#0a1422',
    color: '#a8b9d4',
    fontSize: '13px',
    fontWeight: 700,
    border: '1px solid #1b2d46',
    cursor: 'pointer',
  },
  pillActive: {
    background: '#0e4ca4',
    color: '#ffffff',
    borderColor: '#2d69c0',
  },
  tableWrap: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    textAlign: 'left',
    padding: '14px 20px',
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: '#7f93b3',
    background: '#091321',
  },
  td: {
    padding: '16px 20px',
    borderTop: '1px solid #14253b',
    fontSize: '14px',
    color: '#cfe0f8',
    verticalAlign: 'top',
  },
  userName: {
    fontWeight: 700,
    color: '#f8fbff',
  },
  userEmail: {
    marginTop: '4px',
    color: '#8ea5c7',
    fontSize: '13px',
  },
  rowActions: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  smallButton: {
    padding: '8px 12px',
    borderRadius: '12px',
    border: '1px solid #223754',
    background: '#101d31',
    fontSize: '12px',
    fontWeight: 700,
    color: '#d5e2f7',
    cursor: 'pointer',
  },
  dangerButton: {
    padding: '8px 12px',
    borderRadius: '12px',
    border: '1px solid #5b2634',
    background: '#2a1319',
    fontSize: '12px',
    fontWeight: 700,
    color: '#ffb7c3',
    cursor: 'pointer',
  },
  statusBase: {
    display: 'inline-block',
    borderRadius: '999px',
    padding: '6px 12px',
    fontSize: '12px',
    fontWeight: 700,
    border: '1px solid transparent',
  },
  sideColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  sectionBody: {
    padding: '20px',
  },
  quickGrid: {
    display: 'grid',
    gap: '12px',
  },
  quickButton: {
    width: '100%',
    textAlign: 'left',
    padding: '14px 16px',
    borderRadius: '16px',
    border: '1px solid #1b2d46',
    background: '#091321',
    fontSize: '14px',
    fontWeight: 600,
    color: '#d5e2f7',
    cursor: 'pointer',
  },
  ticketList: {
    display: 'grid',
    gap: '12px',
  },
  ticketCard: {
    border: '1px solid #1b2d46',
    borderRadius: '18px',
    padding: '16px',
    background: '#091321',
  },
  ticketTop: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '12px',
    alignItems: 'flex-start',
  },
  ticketId: {
    fontSize: '11px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: '#7287a8',
  },
  ticketSubject: {
    marginTop: '6px',
    fontWeight: 700,
    color: '#f8fbff',
  },
  ticketOwner: {
    marginTop: '6px',
    fontSize: '13px',
    color: '#8ea5c7',
  },
  badge: {
    borderRadius: '999px',
    padding: '6px 10px',
    fontSize: '12px',
    fontWeight: 700,
    border: '1px solid transparent',
  },
  bottomGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
    marginTop: '24px',
  },
  progressBlock: {
    marginBottom: '18px',
  },
  progressHead: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '14px',
    marginBottom: '8px',
  },
  progressLabel: {
    fontWeight: 600,
    color: '#d5e2f7',
  },
  progressCount: {
    color: '#8ea5c7',
  },
  progressTrack: {
    height: '12px',
    borderRadius: '999px',
    background: '#091321',
    overflow: 'hidden',
    border: '1px solid #1b2d46',
  },
  progressBar: {
    height: '100%',
    borderRadius: '999px',
    background: 'linear-gradient(90deg, #0e4ca4 0%, #2d69c0 100%)',
  },
  activityList: {
    display: 'grid',
    gap: '16px',
  },
  activityRow: {
    display: 'flex',
    gap: '12px',
  },
  activityDot: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    background: '#0e4ca4',
    marginTop: '5px',
    flexShrink: 0,
    boxShadow: '0 0 0 4px rgba(14, 76, 164, 0.16)',
  },
  activityText: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#dce9ff',
  },
  activityTime: {
    fontSize: '12px',
    color: '#8ea5c7',
    marginTop: '4px',
  },
};

function mergeStyles(...items) {
  return Object.assign({}, ...items);
}

function statusStyle(status) {
  const map = {
    Active: { background: '#0f3320', color: '#7ef0a6', borderColor: '#1d5a37' },
    Pending: { background: '#3a2b08', color: '#ffd36c', borderColor: '#6b4f10' },
    Suspended: { background: '#35131a', color: '#ff9fb2', borderColor: '#65303c' },
    Inactive: { background: '#162234', color: '#a7bddc', borderColor: '#2a405f' },
  };
  return mergeStyles(styles.statusBase, map[status] || {});
}

function priorityStyle(priority) {
  const map = {
    High: { background: '#35131a', color: '#ff9fb2', borderColor: '#65303c' },
    Medium: { background: '#3a2b08', color: '#ffd36c', borderColor: '#6b4f10' },
    Low: { background: '#102b45', color: '#8fd0ff', borderColor: '#295c87' },
  };
  return mergeStyles(styles.badge, map[priority] || {});
}

export default function AdminDashboard() {
  const stats = [
    { label: 'Total Users', value: '2,481', change: '+12.4%', note: 'vs last month' },
    { label: 'Active Sessions', value: '384', change: '+5.1%', note: 'currently online' },
    { label: 'Pending Tickets', value: '27', change: '-8.3%', note: 'support queue' },
    { label: 'Monthly Revenue', value: '$48,920', change: '+18.7%', note: 'this month' },
  ];

  const users = [
    {
      name: <TextLineSkeleton />,
      email: '',
      role: <TextLineSkeleton />,
      status: <TextLineSkeleton />,
      plan: <TextLineSkeleton />,
      joined: <TextLineSkeleton />,
      lastLogin: <TextLineSkeleton />,
    },
    {
      name: <TextLineSkeleton />,
      email: '',
      role: <TextLineSkeleton />,
      status: <TextLineSkeleton />,
      plan: <TextLineSkeleton />,
      joined: <TextLineSkeleton />,
      lastLogin: <TextLineSkeleton />,
    },
    {
      name: <TextLineSkeleton />,
      email: '',
      role: <TextLineSkeleton />,
      status: <TextLineSkeleton />,
      plan: <TextLineSkeleton />,
      joined: <TextLineSkeleton />,
      lastLogin: <TextLineSkeleton />,
    },
    {
      name: <TextLineSkeleton />,
      email: '',
      role: <TextLineSkeleton />,
      status: <TextLineSkeleton />,
      plan: <TextLineSkeleton />,
      joined: <TextLineSkeleton />,
      lastLogin: <TextLineSkeleton />,
    },
    {
      name: <TextLineSkeleton />,
      email: '',
      role: <TextLineSkeleton />,
      status: <TextLineSkeleton />,
      plan: <TextLineSkeleton />,
      joined: <TextLineSkeleton />,
      lastLogin: <TextLineSkeleton />,
    },
    {
      name: <TextLineSkeleton />,
      email: '',
      role: <TextLineSkeleton />,
      status: <TextLineSkeleton />,
      plan: <TextLineSkeleton />,
      joined: <TextLineSkeleton />,
      lastLogin: <TextLineSkeleton />,
    },
    {
      name: <TextLineSkeleton />,
      email: '',
      role: <TextLineSkeleton />,
      status: <TextLineSkeleton />,
      plan: <TextLineSkeleton />,
      joined: <TextLineSkeleton />,
      lastLogin: <TextLineSkeleton />,
    },
    {
      name: <TextLineSkeleton />,
      email: '',
      role: <TextLineSkeleton />,
      status: <TextLineSkeleton />,
      plan: <TextLineSkeleton />,
      joined: <TextLineSkeleton />,
      lastLogin: <TextLineSkeleton />,
    },
    {
      name: <TextLineSkeleton />,
      email: '',
      role: <TextLineSkeleton />,
      status: <TextLineSkeleton />,
      plan: <TextLineSkeleton />,
      joined: <TextLineSkeleton />,
      lastLogin: <TextLineSkeleton />,
    },
    {
      name: <TextLineSkeleton />,
      email: '',
      role: <TextLineSkeleton />,
      status: <TextLineSkeleton />,
      plan: <TextLineSkeleton />,
      joined: <TextLineSkeleton />,
      lastLogin: <TextLineSkeleton />,
    },
    {
      name: <TextLineSkeleton />,
      email: '',
      role: <TextLineSkeleton />,
      status: <TextLineSkeleton />,
      plan: <TextLineSkeleton />,
      joined: <TextLineSkeleton />,
      lastLogin: <TextLineSkeleton />,
    },
    {
      name: <TextLineSkeleton />,
      email: '',
      role: <TextLineSkeleton />,
      status: <TextLineSkeleton />,
      plan: <TextLineSkeleton />,
      joined: <TextLineSkeleton />,
      lastLogin: <TextLineSkeleton />,
    },
    {
      name: 'Sophia Carter',
      email: 'sophia.carter@example.com',
      role: 'Manager',
      status: 'Active',
      plan: 'Business',
      joined: 'Dec 03, 2025',
      lastLogin: '18 minutes ago',
    },
    {
      name: 'James Walker',
      email: 'james.walker@example.com',
      role: 'Support',
      status: 'Suspended',
      plan: 'Professional',
      joined: 'Nov 21, 2025',
      lastLogin: '3 days ago',
    },
    {
      name: 'Emily Foster',
      email: 'emily.foster@example.com',
      role: 'Editor',
      status: 'Pending',
      plan: 'Starter',
      joined: 'Feb 09, 2026',
      lastLogin: 'Never',
    },
    {
      name: 'William Hayes',
      email: 'william.hayes@example.com',
      role: 'Analyst',
      status: 'Active',
      plan: 'Business',
      joined: 'Oct 17, 2025',
      lastLogin: '1 hour ago',
    },
    {
      name: 'Charlotte Reed',
      email: 'charlotte.reed@example.com',
      role: 'Moderator',
      status: 'Inactive',
      plan: 'Professional',
      joined: 'Sep 02, 2025',
      lastLogin: '12 days ago',
    },
  ];

  const tickets = [
    // { id: 'TK-1024', subject: 'Billing adjustment request', priority: 'High', owner: 'Sophia Carter' },
    // { id: 'TK-1025', subject: 'User access review', priority: 'Medium', owner: 'Oliver Bennett' },
    // { id: 'TK-1026', subject: 'Export report issue', priority: 'Low', owner: 'William Hayes' },
  ];

  const activities = [
    'Oliver Bennett changed user permissions for James Walker.',
    'Sophia Carter approved a refund for Northbridge Systems.',
    'Emily Foster requested administrator access.',
    'William Hayes exported the monthly usage report.',
    'Charlotte Reed failed 3 login attempts from a new device.',
  ];

  const permissions = [
    { role: 'Administrators', count: 12, width: '82%' },
    { role: 'Managers', count: 34, width: '68%' },
    { role: 'Editors', count: 86, width: '54%' },
    { role: 'Support', count: 41, width: '44%' },
    { role: 'View Only', count: 172, width: '30%' },
  ];

  const navItems = ['Overview', 'Users', 'Permissions', 'Reports', 'Billing', 'Support', 'Settings'];

  return (
    <div style={styles.page}>
      <div style={styles.layout}>
        <aside style={styles.sidebar}>
          <div style={styles.sidebarHeader}>
            <div style={styles.sidebarLabel}>Control Panel</div>
            <div style={styles.sidebarTitle}>Admin Dashboard</div>
          </div>

          <nav style={styles.nav}>
            {navItems.map((item, index) => (
              <button
                key={item}
                style={mergeStyles(styles.navButton, index === 0 ? styles.navButtonActive : null)}
              >
                <span>{item}</span>
                {item === 'Support' ? <span style={styles.supportBadge}></span> : null}
              </button>
            ))}
          </nav>

          <div style={styles.systemBoxWrap}>
            <div style={styles.systemBox}>
              <div style={styles.systemTitle}>System Status</div>
              <div style={styles.systemStatus}>Operational</div>
              <div style={styles.systemText}>All services are running normally.</div>
            </div>
          </div>
        </aside>

        <main style={styles.main}>
          <header style={styles.header}>
            <div>
              <h1 style={styles.headerTitle}>Administration Overview</h1>
              <div style={styles.headerText}>
                Monitor users, permissions, support, billing, and platform activity.
              </div>
            </div>

            <div style={styles.headerActions}>
              <input
                type="text"
                placeholder="Search users, tickets, reports..."
                style={styles.search}
              />
              <button style={styles.buttonLight}>Export Data</button>
              <button style={styles.buttonDark}>Add User</button>
            </div>
          </header>

          <div style={styles.content}>
            <section style={styles.statsGrid}>
              {stats.map((item) => (
                <div key={item.label} style={mergeStyles(styles.card, styles.statCard)}>
                  <div style={styles.statLabel}>{item.label}</div>
                  <div style={styles.statRow}>
                    <div style={styles.statValue}><TextLineSkeleton /></div>
                    <div style={styles.changeBadge}></div>
                  </div>
                  <div style={styles.statNote}>{item.note}</div>
                </div>
              ))}
            </section>

            <section style={styles.splitGrid}>
              <div style={styles.card}>
                <div style={styles.panelHeader}>
                  <div>
                    <h2 style={styles.panelTitle}>User Management</h2>
                    <div style={styles.panelText}>Recent accounts, roles, access level, and status.</div>
                  </div>
                  <div style={styles.pillRow}>
                    <button style={mergeStyles(styles.pill, styles.pillActive)}>All</button>
                    <button style={styles.pill}>Active</button>
                    <button style={styles.pill}>Pending</button>
                    <button style={styles.pill}>Suspended</button>
                  </div>
                </div>

                <div style={styles.tableWrap}>
                  <table style={styles.table}>
                    <thead>
                      <tr>
                        <th style={styles.th}>User</th>
                        <th style={styles.th}>Role</th>
                        <th style={styles.th}>Plan</th>
                        {/* <th style={styles.th}>Status</th> */}
                        <th style={styles.th}>Joined</th>
                        <th style={styles.th}>Last Login</th>
                        <th style={styles.th}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((user) => (
                        <tr key={user.email}>
                          <td style={styles.td}>
                            <div style={styles.userName}>{user.name}</div>
                            <div style={styles.userEmail}>{user.email}</div>
                          </td>
                          <td style={styles.td}>{user.role}</td>
                          <td style={styles.td}>{user.plan}</td>
                          {/* <td style={styles.td}>
                            <span style={statusStyle(user.status)}>{user.status}</span>
                          </td> */}
                          <td style={styles.td}>{user.joined}</td>
                          <td style={styles.td}>{user.lastLogin}</td>
                          <td style={styles.td}>
                            <div style={styles.rowActions}>
                              <button style={styles.smallButton}>Edit</button>
                              <button style={styles.smallButton}>View</button>
                              <button style={styles.dangerButton}>Disable</button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div style={styles.sideColumn}>
                <div style={styles.card}>
                  <div style={styles.panelHeader}>
                    <div>
                      <h2 style={styles.panelTitle}>Quick Actions</h2>
                      <div style={styles.panelText}>Admin tools</div>
                    </div>
                  </div>
                  <div style={styles.sectionBody}>
                    <div style={styles.quickGrid}>
                      {[
                        'Reset user password',
                        'Grant elevated permissions',
                        'Review audit logs',
                        'Generate billing report',
                        'Lock suspicious account',
                      ].map((action) => (
                        <button key={action} style={styles.quickButton}>{action}</button>
                      ))}
                    </div>
                  </div>
                </div>

                <div style={styles.card}>
                  <div style={styles.panelHeader}>
                    <div>
                      <h2 style={styles.panelTitle}>Open Tickets</h2>
                      <div style={styles.panelText}>Support queue</div>
                    </div>
                  </div>
                  <div style={styles.sectionBody}>
                    <div style={styles.ticketList}>
                      {tickets.map((ticket) => (
                        <div key={ticket.id} style={styles.ticketCard}>
                          <div style={styles.ticketTop}>
                            <div>
                              <div style={styles.ticketId}>{ticket.id}</div>
                              <div style={styles.ticketSubject}>{ticket.subject}</div>
                              <div style={styles.ticketOwner}>Owner: {ticket.owner}</div>
                            </div>
                            <span style={priorityStyle(ticket.priority)}>{ticket.priority}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section style={styles.bottomGrid}>
              <div style={styles.card}>
                <div style={styles.panelHeader}>
                  <div>
                    <h2 style={styles.panelTitle}>Permissions Summary</h2>
                    <div style={styles.panelText}>Overview of access distribution.</div>
                  </div>
                  <button style={styles.buttonLight}>Manage Roles</button>
                </div>
                <div style={styles.sectionBody}>
                  {permissions.map((item) => (
                    <div key={item.role} style={styles.progressBlock}>
                      <div style={styles.progressHead}>
                        <span style={styles.progressLabel}>{item.role}</span>
                        <span style={styles.progressCount}>{item.count} users</span>
                      </div>
                      <div style={styles.progressTrack}>
                        <div style={mergeStyles(styles.progressBar, { width: item.width })} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div style={styles.card}>
                <div style={styles.panelHeader}>
                  <div>
                    <h2 style={styles.panelTitle}>Recent Activity</h2>
                    <div style={styles.panelText}>Latest administrative actions and alerts.</div>
                  </div>
                  <button style={styles.buttonLight}>View Logs</button>
                </div>
                <div style={styles.sectionBody}>
                  <div style={styles.activityList}>
                    {activities.map((activity, index) => (
                      <div key={activity} style={styles.activityRow}>
                        <div style={styles.activityDot} />
                        <div>
                          <div style={styles.activityText}>{activity}</div>
                          <div style={styles.activityTime}>{index + 1} hour{index === 0 ? '' : 's'} ago</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </div>
      <ErrorBanner />
    </div>
  );
}